/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function e(e){let n=e.parentElement,t=null;for(;n&&!(n instanceof HTMLFieldSetElement);)n instanceof HTMLLegendElement&&(t=n),n=n.parentElement;let l=""===(null==n?void 0:n.getAttribute("disabled"));return(!l||!function(e){if(!e)return!1;let n=e.previousElementSibling;for(;null!==n;){if(n instanceof HTMLLegendElement)return!1;n=n.previousElementSibling}return!0}(t))&&l}export{e as isDisabledReactIssue7711};
//# sourceMappingURL=bugs.js.map
